import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, FormControl } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CustomPagination from '../../CustomPagination';
import CurrencyConverter from '../../CurrencyConverter';
import Loader from '../../../components/Common/Loader';


import messages from '../../../locale/messages';
import debounce from '../../../helpers/debounce';
import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirst';
import { demoRestrictionEncode } from '../../../actions/demoRestriction';
import { censorWord, decode } from '../../../helpers/queryEncryption';

import bt from '../../../components/commonStyle.css';
import s from './FailedPayoutList.css';
export class FailedPayoutList extends Component {
	static propTypes = {
		getFailedPayoutData: PropTypes.object,
	}
	constructor(props) {
		super(props)

		this.state = {
			currentPage: 1,
			isRestrict: false
		}
	}

	async componentDidMount() {
		const { demoRestrictionEncode } = this.props;
		const isRestrict = await demoRestrictionEncode({});
		this.setState({ isRestrict });
	}

	handleKeywordSearch = debounce((searchList) => {
		const { getFailedPayoutData: { refetch } } = this.props
		let variables = {
			currentPage: 1,
			searchList: searchList
		}
		this.setState(variables)
		refetch(variables)
	}, 250);

	paginationData = (currentPage) => {
		const { getFailedPayoutData: { refetch } } = this.props;
		let variables = { currentPage };
		this.setState({ currentPage });
		refetch(variables);
	}

	render() {
		const { getFailedPayoutData, getFailedPayoutData: { getFailedPayoutList, loading } } = this.props;
		const { currentPage, isRestrict } = this.state;
		const { formatMessage } = this.props.intl;
		return (
			<div>
				<div className={cx(s.searchInput, 'searchInputRTL')}>
					<FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} className={bt.formControlInput} />
				</div>
				{
					loading && <div>
						<Loader type="circle" />
					</div>
				}
				{!loading &&
					<div className={cx('tableOuterContainer', bt.spaceTop4)}>
						<Table className="tableContainer">
							<thead>
								<tr>
									<th scope="col"><FormattedMessage {...messages.jobId} /></th>
									<th scope="col"><FormattedMessage {...messages.partnerName} /></th>
									<th scope="col"><FormattedMessage {...messages.amount} /></th>
									<th scope="col"><FormattedMessage {...messages.reason} /></th>
								</tr>
							</thead>
							<tbody>
								{
									getFailedPayoutData && getFailedPayoutData.getFailedPayoutList && getFailedPayoutData.getFailedPayoutList.results && getFailedPayoutData.getFailedPayoutList.results.length > 0 && getFailedPayoutData.getFailedPayoutList.results.map((item, index) => {
										return (
											<tr key={index}>
												<td data-label={formatMessage(messages.jobId)}>{item.bookingId}</td>
												<td data-label={formatMessage(messages.partnerName)}>{item && item.partnerDetails && capitalizeFirstLetter(isRestrict ? censorWord(decode(item.partnerDetails.encryptFirstName)) : decode(item.partnerDetails.encryptFirstName))}</td>
												<td data-label={formatMessage(messages.amount)}><CurrencyConverter from={item.currency} amount={item.amount} /></td>
												<td data-label={formatMessage(messages.reason)}>{item.reason}</td>
											</tr>
										)
									})
								}
								{
									!loading && getFailedPayoutData && getFailedPayoutData.getFailedPayoutList && getFailedPayoutData.getFailedPayoutList.results && getFailedPayoutData.getFailedPayoutList.results.length == 0 && (
										<tr>
											<td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
										</tr>
									)
								}
							</tbody>
						</Table>
					</div>
				}
				{
					getFailedPayoutData && getFailedPayoutData.getFailedPayoutList && getFailedPayoutData.getFailedPayoutList.results && getFailedPayoutData.getFailedPayoutList.results.length > 0
					&& <div className={cx(bt.space5, bt.spaceTop5)}>
						<CustomPagination
							total={getFailedPayoutData.getFailedPayoutList.count}
							currentPage={currentPage}
							defaultCurrent={1}
							defaultPageSize={10}
							change={this.paginationData}
							paginationLabel={formatMessage(messages.partnerPayout)}
						/>
					</div>
				}
			</div>
		)
	}
}

const mapState = (state) => ({});

const mapDispatch = {
	demoRestrictionEncode
}

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(FailedPayoutList)));